<div class="page-item" [class.connected]="page.connected" @pageAnimation>
  <!-- Picture & name & id -->
  <div class="d-flex flex-grow-1 align-items-center">
    <img class="channel-logo" [src]="'assets/img/icons/' + page.channel + '-icon.png'" />
    <img *ngIf="mode !== 'add'" class="page-picture" [src]="pictureUrl" alt="Logo de la page" />
    <div *ngIf="mode === 'add'" class="add-placeholder">+</div>
    <div class="page-name" title="{{ name }}">
      {{ name }}
      <a *ngIf="mode !== 'add'" target="_blank" [href]="'https://www.facebook.com/' + page.id" (click)="$event.stopPropagation()"
        ><i class="fas fa-external-link-alt" title="Ouvrir"></i
      ></a>
    </div>
    <strong *ngIf="mode !== 'add' && page?.id && !compact">Page id : {{ page?.id }}</strong>
  </div>

  <!-- Action buttons -->
  <div class="d-flex flex-shrink-0 align-items-center mt-2 mt-md-0 mx-auto mx-md-0" *ngIf="mode === 'manage'">
    <!-- Link to inbox -->
    <button
      *ngIf="!page.linkId"
      type="button"
      class="btn btn-sm btn-primary mr-2 ml-auto d-flex align-items-center"
      [disabled]="!canLink"
      (click)="linkPage()"
    >
      Connect to INBOX
      <i
        class="fa fa-info-circle d-none d-md-block"
        aria-hidden="true"
        [tooltip]="'As a paying user, you can link up this page with our IDETA inbox tool'"
      ></i>
    </button>

    <!-- Linked to inbox -->
    <div [tooltip]="'Inbox is linked to your page.'" *ngIf="page.linkId">
      <span class="text-success mb-3 mr-2">LINKED UP ✅ </span>
    </div>

    <!-- Disconnect -->
    <button
      *ngIf="page.connected"
      type="button"
      class="btn btn-sm btn-danger mr-auto"
      (click)="disconnectPage(page)"
      appProtocolDroid="idechat.deployment.fb-options.page-item.disconnect"
    >
      Déconnecter
    </button>
  </div>
</div>
